<script>
  import LayoutGrid, { Cell } from "@smui/layout-grid";
  import Paper from "@smui/paper";

  import NumberElt from "./Number.svelte";
  import Currency from "./Currency.svelte";
  import SlideYear from "../calculate/SlideYear.svelte";

  import { workingDays, globalState } from '../store/store.js';

  export let result = undefined;
  export let resultYearWithoutVacation = undefined;
  export let resultVacation = undefined;
  export let resultYearWithVacation = undefined;
  export let privateVersion = false;

  let firstName = null;
  let lastName = null;
  let monthYearStore = null;
  let monthYear = null;
  let currentDate = new Date();

  let vacation = false;

  for (const [key, value] of Object.entries($globalState)) {
    if ('o' === key) {
      firstName = value;
    } else if ('p' === key) {
      lastName = value;
    } else if ('n' === key) {
      monthYearStore = value;
    } else if ('s' === key) {
      vacation = value
    }
  }

  if (monthYearStore) {
    let [year, month] = monthYearStore.split("-");
    let myDate = new Date(year, month - 1, 1);
    monthYear = new Intl.DateTimeFormat("fr-FR", {
      month: "long",
      year: "numeric"
    }).format(myDate);
  } else {
    monthYear = new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' }).format(currentDate);
  }
  monthYear = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);

  function getValue(result, key, period = "monthly") {
    let periodFactor = period === "yearly" && key !== "dailyRate" ? 12 : 1;
    return result[key] * periodFactor;
  }

  const params = new URLSearchParams();

  for (const [key, value] of Object.entries($globalState)) {
    if (value !== null && value !== undefined) {
      params.append(key, value);
    }
  }
</script>

<LayoutGrid style="padding: 0">
    <Cell span={1} spanDevices={{ tablet:0, phone: 0 }} class="resume-salary"></Cell>
    <Cell span={5} spanDevices={{ tablet:6, phone: 12 }} class="resume-salary">
        <SlideYear result={resultYearWithoutVacation} strong={true} {privateVersion}/>
        <br/><br/>
        <SlideYear result={resultVacation} strong={true} simulatorVacation={true} {privateVersion}/>
    </Cell>
    <Cell span={5} spanDevices={{ tablet:6, phone: 12 }} class="resume-salary">
        <SlideYear result={resultYearWithVacation} simulatorVacation={true} {privateVersion}/>
    </Cell>
    <Cell span={1} spanDevices={{ tablet:0, phone: 0 }} class="resume-salary"></Cell>
    <Cell span={12} style="min-height: 50px;" class="resume-salary"></Cell>
    <Cell span={8} class="no-web" style="min-height: 50px;"/>
    <Cell span={8} class="no-web">
        <Paper color="primary" variant="outlined" class="orange" style="text-align:center;font-weight:bold;">
            <h2>CONCRETIO</h2>
            <span>Période : {monthYear}</span>
            <br><br>
            Simulation pour l'adhérent
            {#if firstName || lastName}
                <span>{firstName} {lastName}</span>
            {/if}
            <!--Nom Consultant-->
            <br><br>

            <span>Estimation mensuelle sur <NumberElt number={$workingDays}/> </span>
            <span>jours </span>
            <span> pour un TJM de <Currency number={getValue(result, "dailyRate")}/> </span>
            {#if result.metadata.input.hasMutuelle}
                <span>avec mutuelle et </span>
            {:else}
                <span>sans mutuelle et </span>
            {/if}
            {#if vacation}
                <span>congé payés.</span>
            {:else}
                <span>congés provisionnés.</span>
            {/if}
        </Paper>
    </Cell>
    <Cell span={1} class="no-web"/>
    <Cell span={6} class="no-web">
        <SlideYear result={resultYearWithoutVacation} strong={true} {privateVersion}/>
    </Cell>
    <Cell span={1} class="no-web"/>
    <Cell span={1} class="no-web"/>
    <Cell span={6} class="no-web">
        <SlideYear result={resultYearWithVacation} simulatorVacation={true} {privateVersion}/>
    </Cell>
    <Cell span={1} class="no-web"/>
    <Cell span={1} class="no-web"/>
    <Cell span={6} class="no-web">
        <SlideYear result={resultVacation} strong={true} simulatorVacation={true} {privateVersion}/>
    </Cell>
    <Cell span={1} class="no-web"/>
</LayoutGrid>
<LayoutGrid style="padding: 0" class="download">
    <Cell span={12}>
        <Paper color="primary" variant="outlined" class="orange" style="text-align:center;font-weight:bold;">
            <h3>CONCRETIO</h3>
            <span>Période : {monthYear}</span>
            <br><br>
            <span>Simulation pour l'adhérent</span>
            {#if firstName || lastName}
                <span>{firstName} {lastName}</span>
            {/if}
            <!--Nom Consultant-->
            <br><br>

            <span>Estimation mensuelle sur <NumberElt number={$workingDays}/> </span>
            <span>jours </span>
            <span> pour un TJM de <Currency number={getValue(result, "dailyRate")}/> </span>
            {#if result.metadata.input.hasMutuelle}
                <span>avec mutuelle et </span>
            {:else}
                <span>sans mutuelle et </span>
            {/if}
            {#if vacation}
                <span>congé payés.</span>
            {:else}
                <span>congés provisionnés.</span>
            {/if}
        </Paper>
    </Cell>
    <Cell span={3}/>
    <Cell span={6}>
        <SlideYear result={resultYearWithoutVacation} strong={true} {privateVersion}/>
    </Cell>
    <Cell span={3}/>
    <Cell span={3}/>
    <Cell span={6}>
        <SlideYear result={resultYearWithVacation} simulatorVacation={true} {privateVersion}/>
    </Cell>
    <Cell span={3}/>
    <Cell span={3}/>
    <Cell span={6}>
        <SlideYear result={resultVacation} strong={true} simulatorVacation={true} {privateVersion}/>
    </Cell>
    <Cell span={3}/>
</LayoutGrid>